// @flow
import { connect } from 'react-redux';

import ModalFormLoge from 'components/entreprise/loge/ModalFormLoge';
import { postContactForm } from 'actions/formActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/entreprise/loge/ModalFormLoge';

export default connect(
  (state: StateType): StateProps => ({
    contactFormList: state.formState.contactFormList,
    fetchStatus: state.formState.fetchStatus,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    onSubmit: (formInputs: Object, id: number) => dispatch(postContactForm(formInputs, id)),
  })
)(ModalFormLoge);
